import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

/* ------------ shared look & feel ------------ */
const gradient = keyframes`
  0%{background-position:0 50%}
  50%{background-position:100% 50%}
  100%{background-position:0 50%}
`;

const Wrapper = styled.section`
  background: linear-gradient(135deg,#28346c 0%,#2c397a 25%,#232c5c 50%,#2c397a 75%,#28346c 100%);
  background-size:400% 400%;
  animation:${gradient} 15s ease infinite;
  color:#fff;
  text-align:center;
  padding:6rem 2rem 5rem;
  min-height:70vh;
  display:flex;
  flex-direction:column;
  justify-content:center;
`;

const Heading = styled.h1`
  font-size:2.8rem;
  margin-bottom:1rem;
  color: white;
  @media(max-width:768px){font-size:2.2rem;}
`;

const Message = styled.p`
  font-size:1.3rem;
  color: white;
  max-width:1000px;
  margin:0 auto 3rem;
  line-height:1.5;
  @media(max-width:768px){font-size:1.1rem;}
`;

const Button = styled(Link)`
  display:inline-block;
  background:#fff;
  color:#28346c;
  font-weight:600;
  padding:0.875rem 2rem;
  margin:0 auto 3rem;
  border-radius:4px;
  box-shadow:0 4px 6px rgba(0,0,0,.1);
  transition:all .3s;
  &:hover{transform:translateY(-2px);box-shadow:0 6px 15px rgba(40,52,108,.3);}
`;

const ThankYou = () => {
  const navigate = useNavigate();

  /* optional auto-return to home after 8 s */
  useEffect(() => {
    const id = setTimeout(() => navigate('/'), 8000);
    return () => clearTimeout(id);
  }, [navigate]);

  useEffect(() => {
    document.title = 'Thanks for reaching out | Capstone Healthcare Staffing';
  }, []);

  return (
    <Wrapper>
      <Heading>Thank You!</Heading>
      <Message>
        We’ve received your message and a team member will be in touch shortly. <br />
        You’ll be redirected to our homepage in a few seconds, or click below.
      </Message>
      <Button to="/">Return Home</Button>
    </Wrapper>
  );
};

export default ThankYou;
